// extracted by mini-css-extract-plugin
export default {"main":"News_main__MmnOt","cont":"News_cont__W08dZ","img":"News_img__J+eY8","title":"News_title__zXiE2","card":"News_card__EmRjX","date":"News_date__AF2it"};